exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.background-layers-group > .custom-radio {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 2rem;\n}\n.background-layers-group > .custom-radio:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.background-layers-group .custom-control-label {\n  width: 100%;\n  cursor: pointer;\n}\n@keyframes fadeIn {\n50% {\n    transform: scale(1.5);\n}\n}\n.blayer-error-icon {\n  margin-top: 0.12rem;\n  margin-right: 0.5rem;\n  animation-name: fadeIn;\n  animation-duration: 250ms;\n  animation-fill-mode: forwards;\n  animation-timing-function: cubic-bezier(0.0, 0.0, 0.2, 1);\n}\n", ""]);

// exports
